module.exports = __webpack_public_path__ + "static/media/modelC3.a6ff8115.gif";